/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_ColInputs */

const en_settings_apikeys_key_col = /** @type {(inputs: Settings_Apikeys_Key_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Settings_Apikeys_Key_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_col = /** @type {((inputs?: Settings_Apikeys_Key_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_key_col(inputs)
});
export { settings_apikeys_key_col as "settings.apikeys.key_col" }